import React, { PureComponent } from 'react'
import {
  Route,
  Switch,
} from 'react-router-dom'

import LoadingContainer from './Views/Loading/Loading.container'
import LoginContainer from './Views/Auth/Login.container'
import BaseContainer from './Views/Base.container'

export default class RoutesComponent extends PureComponent {
  render() {
    return (
      <Switch>
        <Route exact path='/' component={LoadingContainer} />
        <Route exact path='/login' component={LoginContainer}/>
        <Route path='/dashboard' title='MENU PRINCIPAL' component={BaseContainer}/>
      </Switch>
    )
  }
}
